import { ErrorData } from '../../models/ErrorData';
import * as types from './actionTypes.errors';

export interface ISentErrorParam {
    error: ErrorData;
    noToaster?: boolean
}

export const sentError = (params: ISentErrorParam) => ({
    type: types.SENT_ERROR_REQ,
    ...params,
});